var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Chat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M12.0421 0C5.05959 0 0 5.69654 0 12.018C0 14.0371 0.588883 16.1162 1.62243 18.015C1.81472 18.3275 1.83876 18.7241 1.70656 19.0966L0.901352 21.7887C0.721082 22.4377 1.27391 22.9184 1.88683 22.7261L4.31447 22.005C4.97546 21.7887 5.49224 22.0651 6.10636 22.4377C7.86099 23.4712 10.0471 24 12.018 24C17.979 24 24.0361 19.3971 24.0361 11.982C24.0361 5.58838 18.8683 0 12.0421 0Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.45432 10.4904C7.3076 10.4904 7.99263 11.1754 7.99263 12.0287C7.99263 12.87 7.3076 13.555 6.45432 13.567C5.61306 13.567 4.91602 12.87 4.91602 12.0287C4.91602 11.1754 5.60104 10.4904 6.45432 10.4904ZM11.9951 10.4904C12.8484 10.4904 13.5334 11.1754 13.5334 12.0287C13.5334 12.87 12.8484 13.567 11.9951 13.567C11.1418 13.555 10.4568 12.87 10.4568 12.0167C10.4568 11.1754 11.1539 10.4784 11.9951 10.4904ZM17.5352 10.4904C18.3885 10.4904 19.0735 11.1754 19.0735 12.0287C19.0735 12.87 18.3885 13.567 17.5352 13.567C16.6819 13.567 15.9969 12.87 15.9969 12.0287C15.9969 11.1754 16.6819 10.4904 17.5352 10.4904Z",
    fill: "#E5B910"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6383644d719953691ccc2eb9ff9eff99.svg";
export { ForwardRef as ReactComponent };